import {
  ArchiveRestoreIcon,
  BadgeCheckIcon,
  BriefcaseIcon,
  EyeIcon,
  GraduationCapIcon,
  KeyRoundIcon,
  LandmarkIcon,
  LockIcon,
  NetworkIcon,
  ServerIcon,
  SproutIcon,
  StoreIcon,
  WalletIcon,
  ShieldCheckIcon,
  SparklesIcon,
} from 'lucide-react'
import type { CompanyCard, CompanyStat, Credential, Leader } from '../types/company'

export const companyImages = {
  aboutHero: 'https://cdn.magicpatterns.com/patterns/generated-images/7aa8a4e9-9a2a-4af7-9800-98796172e259.jpg',
  aboutStory: 'https://cdn.magicpatterns.com/patterns/generated-images/ed47f48b-6317-43e6-84df-60d9764e9b8a.jpg',
  securityFunds: 'https://cdn.magicpatterns.com/patterns/generated-images/4ff78b30-2440-43fc-9d39-b114298224f3.jpg',
}

export const officeAddress = '57A KG 215 St, Kigali'

/* ---------- About ---------- */

export const aboutStats: CompanyStat[] = [
  { value: '10,000+', label: 'businesses signed up' },
  { value: '8,000+', label: 'active every month' },
  { value: 'RWF 10B+', label: 'processed each year' },
  { value: '2021', label: 'founded in Kigali' },
]

export const values: CompanyCard[] = [
  {
    icon: StoreIcon,
    title: 'Built for local businesses',
    text: 'We design for the shop in Nyamirambo and the clinic in Huye, not for a boardroom somewhere else.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Trust and transparency',
    text: 'Clear prices, clear terms, and your money and data handled with care — every time.',
  },
  {
    icon: SparklesIcon,
    title: 'Simple by design',
    text: 'If it takes more than a few taps at a busy counter, we keep working on it.',
  },
  {
    icon: SproutIcon,
    title: 'Growing together',
    text: 'When our customers grow, so do we. We measure success by the businesses we help move forward.',
  },
]

export const whatWeDo: CompanyCard[] = [
  {
    icon: BriefcaseIcon,
    title: 'Business tools',
    text: 'Sales, stock, purchases, expenses, customers, and reports in one connected workspace.',
    href: '/products/sales-pos',
    linkLabel: 'Explore products',
  },
  {
    icon: WalletIcon,
    title: 'Payments',
    text: 'Accept mobile money, card, and bank transfers, with every payment matched to its sale.',
    href: '#',
    linkLabel: 'Learn about payments',
  },
  {
    icon: LandmarkIcon,
    title: 'Business Financing',
    text: 'Turn the records you already keep into access to working capital through licensed partners.',
    href: '/products/business-finance',
    linkLabel: 'Explore Business Financing',
  },
]

export const leaders: Leader[] = [
  { name: '[Name]', title: 'CEO & Co-Founder', linkedin: '#' },
  { name: '[Name]', title: 'CTO & Chairperson', linkedin: '#' },
  { name: '[Name]', title: 'COO', linkedin: '#' },
  { name: '[Name]', title: 'CFO', linkedin: '#' },
  { name: '[Name]', title: 'Head of Risk & Compliance', linkedin: '#' },
]

/* ---------- Security & compliance (PLACEHOLDER COPY — requires compliance review) ---------- */

export const credentials: Credential[] = [
  {
    icon: LandmarkIcon,
    issuer: 'Bank of Rwanda (BNR)',
    name: 'Electronic Money Institution & Payment Service Provider',
    line: 'Kayko Group Ltd is licensed by the National Bank of Rwanda.',
    linkLabel: 'Licence details',
    href: '#',
  },
  {
    icon: BadgeCheckIcon,
    issuer: 'Rwanda Revenue Authority',
    name: 'EBM certified',
    line: 'Invoices and receipts issued through Kayko meet EBM requirements.',
    linkLabel: 'Licence details',
    href: '#',
  },
  {
    icon: NetworkIcon,
    issuer: 'National payments system',
    name: 'RNDPS participant',
    line: 'Participant in the Rwanda National Digital Payments System.',
    linkLabel: 'Licence details',
    href: '#',
  },
]

export const protections: CompanyCard[] = [
  { icon: LockIcon, title: 'Encryption', text: 'Your data is encrypted in transit and at rest using industry-standard methods.' },
  { icon: KeyRoundIcon, title: 'Access controls', text: 'Staff roles, strong sign-in, and least-privilege access keep data with the right people.' },
  { icon: ServerIcon, title: 'Secure hosting', text: 'Kayko runs on secure, access-controlled infrastructure with regular security reviews.' },
  { icon: EyeIcon, title: 'Monitoring', text: 'Systems are monitored around the clock to detect and respond to unusual activity.' },
  { icon: ArchiveRestoreIcon, title: 'Backups', text: 'Regular encrypted backups mean your records can be restored if something goes wrong.' },
  { icon: GraduationCapIcon, title: 'Staff training', text: 'Every team member completes security and data protection training every year.' },
]

export const partnersPlaceholder = 6
